import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Radar } from '@ant-design/plots';
import { Table, Row} from "antd";
import TablePlot from "../../../Admin/Graphs/Table";

export default function PolygonGraph(props) {
   const {datos,nombres} = props;
   var data=[];
   var dataTable=[];
   var realData=[
    {cost_total_eur:datos[0][0]['cost_total_eur'],
    emissions_kgco2:datos[0][0]['emissions_kgco2'],
    tours_avgtime_min:datos[0][0]['tours_avgtime_min'],
    orders_completed:parseInt(datos[0][0]['orders_completed'])/parseInt(datos[0][0]['orders_total']),
    distance_total_km:datos[0][0]['distance_total_km']}
   ];

    for(var i=0;i<datos.length;i++){
      var aux1=parseInt(datos[i][0]['orders_completed'])/parseInt(datos[i][0]['orders_total'])
      realData[0].cost_total_eur= 
        (realData[0].cost_total_eur>parseFloat(datos[i][0]['cost_total_eur']))
        ?parseFloat(datos[i][0]['cost_total_eur'])
        :realData[0].cost_total_eur
      realData[0].emissions_kgco2=
        (realData[0].emissions_kgco2>parseFloat(datos[i][0]['emissions_kgco2']))
        ?parseFloat(datos[i][0]['emissions_kgco2'])
        :realData[0].emissions_kgco2 
      realData[0].tours_avgtime_min=
        (realData[0].tours_avgtime_min>parseFloat(datos[i][0]['tours_avgtime_min']))
        ?parseFloat(datos[i][0]['tours_avgtime_min'])
        :realData[0].tours_avgtime_min
      realData[0].orders_completed=
        (realData[0].orders_completed>aux1)
        ?aux1
        :realData[0].orders_completed
      realData[0].distance_total_km=
        (realData[0].distance_total_km>parseFloat(datos[i][0]['distance_total_km']))
        ?parseFloat(datos[i][0]['distance_total_km'])
        :realData[0].distance_total_km
    }
    
     for(var i=0;i<datos.length;i++){
      var aux1=parseInt(datos[i][0]['orders_completed'])/parseInt(datos[i][0]['orders_total'])
      var aux2=parseInt(datos[i][0]['orders_completedontime'])/parseInt(datos[i][0]['orders_total'])
      data.push({
        item:'% Orders Completed',
        user:nombres[i],
        score:Math.round(100*realData[0].orders_completed/aux1)
      })
      data.push({
        item:'Price',
        user:nombres[i],
        score:Math.round(100*realData[0].cost_total_eur/datos[i][0]['cost_total_eur'])
      })
      data.push({
        item:'CO2 Emissions',
        user:nombres[i],
        score:Math.round(100*realData[0].emissions_kgco2/datos[i][0]['emissions_kgco2'])
      })
      data.push({
        item:'Distance',
        user:nombres[i],
        score:Math.round(100*realData[0].distance_total_km/datos[i][0]['distance_total_km'])
      })
      data.push({
        item:'Time',
        user:nombres[i],
        score:Math.round(100*realData[0].tours_avgtime_min/datos[i][0]['tours_avgtime_min'])
      })
      dataTable.push({
        simulation:nombres[i],
        cost_total_eur:parseFloat(datos[i][0]['cost_total_eur']).toFixed(2),
        emissions_kgco2:parseFloat(datos[i][0]['emissions_kgco2']).toFixed(2),
        tours_avgtime_min:parseFloat(datos[i][0]['tours_avgtime_min']).toFixed(2),
        orders_completed:parseFloat(100*parseInt(datos[i][0]['orders_completed'])/parseInt(datos[i][0]['orders_total'])).toFixed(2),
        distance_total_km:parseFloat(datos[i][0]['distance_total_km']).toFixed(2),
      })

    }

  
  
  const config = {
    data,
    xField: 'item',
    yField: 'score',
    seriesField: 'user',
    meta: {
      score: {
        alias: '分数',
        min: 0,
        max: 100,
      },
    },
    xAxis: {
      line: null,
      tickLine: null,
      grid: {
        line: {
          style: {
            lineDash: null,
          },
        },
      },
    },
    yAxis: {
      line: null,
      tickLine: null,
      grid: {
        line: {
          type: 'line',
          style: {
            lineDash: null,
          },
        },
        alternateColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    area: {},
    point: {
      size: 2,
    },
  };

  const columns1 = [
    {
      title: 'Simulation',
      dataIndex: 'simulation',
      key: 'simulation',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'CO2 Emissions',
      dataIndex: 'emissions_kgco2',
      key: 'emissions_kgco2',
    },
    {
      title: 'Time (min)',
      dataIndex: 'tours_avgtime_min',
      key: 'tours_avgtime_min',
    },
    {
      title: 'Price',
      dataIndex: 'cost_total_eur',
      key: 'cost_total_eur',
    },
    {
      title: '% Ord. Completed',
      dataIndex: 'orders_completed',
      key: 'orders_completed',
    },
    {
      title: 'Distance',
      dataIndex: 'distance_total_km',
      key: 'distance_total_km',
    },
  ]

 
  return (
  <div style={{
    display:'flex',
    flexFlow:'row',
    justifyContent:'space-between',
    alignItems:'center',
    marginRight:'15px',

  }}>
     <div style={{
        display:'flex',
        flexFlow:'column',
        justifyContent:'space-between'
      }}>
      <Table
        dataSource={dataTable}
        columns={columns1}
      />
      </div>
      <div style={{height:'400px',width:'400px',marginBottom:'20px'}}>
    <Radar  {...config} />

      </div>
  </div>
  );
};

